module.exports = __webpack_public_path__ + "cd848480574b5979e4c1af7e8ca94f81.jpg";